import react from "react";
import Request from "../../../../api/Requests";



const postPromoters = (params) => {
    return Request('guestlist-promoters/update-form-promoter', 'POST', params, true);
}



export default {
    postPromoters
}